module.exports = __webpack_public_path__ + "fonts/supply-demand-sid-icon.svg";